import { TranscriptCue } from '../player/player.interface';

export function getCurrentActiveCue(
  cues: TranscriptCue[] | undefined,
  currentTime: number | undefined
): TranscriptCue | undefined {
  return currentTime !== undefined && cues
    ? cues.find(
        (cue, index, cues) =>
          currentTime >= cue.startTime && (!cues[index + 1] || currentTime < cues[index + 1].startTime)
      )
    : undefined;
}
